// extracted by mini-css-extract-plugin
export default {"navTabItem":"_ceee45ab","navTabLink":"_fc83027e","active":"_6bc750fc","panels":"_c5e7e815"};